import { render, staticRenderFns } from "./CourseQuestionCreateAndEditDialog.vue?vue&type=template&id=b9399a0c&scoped=true"
import script from "./CourseQuestionCreateAndEditDialog.vue?vue&type=script&lang=js"
export * from "./CourseQuestionCreateAndEditDialog.vue?vue&type=script&lang=js"
import style0 from "./CourseQuestionCreateAndEditDialog.vue?vue&type=style&index=0&id=b9399a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9399a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSwitch,VTooltip})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
